import { DirectUpload } from "@rails/activestorage"

class ActiveStorageDirectUploader {
  upload: DirectUpload;
  onProgress?: (progress: number) => void;

  constructor(file: File) {
    this.upload = new DirectUpload(file, 
      '/rails/active_storage/direct_uploads', this
    )
  }

  uploadFile({onComplete, onError, onProgress}: {onComplete: (blob: any) => void, onError: (error: any) => void, onProgress: (progress: number) => void}) {
    this.onProgress = onProgress;
    this.upload.create((error: any, blob: any) => {
      if (error) {
        onError(error);
      } else {
        onComplete(blob);
      }
    })
  }

  directUploadWillStoreFileWithXHR(request: XMLHttpRequest) {
    request.upload.addEventListener("progress",
      (event: ProgressEvent) => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event: ProgressEvent) {
    // Use event.loaded and event.total to update the progress bar
    this.onProgress && this.onProgress(Math.round(event.loaded / event.total * 100));
  }
}

export default ActiveStorageDirectUploader;
